import { storeManager } from '@pressreader/appstore';

import { MODULE_NAME } from '../constants';

import { reducer } from './reducers';
import { saga } from './sagas';

storeManager.addFeature(MODULE_NAME, reducer, saga);

export * from './actions';
export * from './selectors';
export * from './sagas';
